import { ReactElement, useCallback, useState } from 'react';

import { CardLoader } from '../../../components/common/Loading';
import { useCommonTranslation } from '../../../hooks/i18n/useCommonTranslation';
import { getSiteById } from '../../../services/sites';
import { SiteData } from '../../../types/sites';
import { errorToast } from '../../../utils/toast';
import { FormLargeDesc, FormTitle } from './AddHospitalForm.styled';
import {
  SITE_SELECT_SEARCH_MIN_LENGTH,
  SiteSelect,
} from '../../../components/views-components/un-auth/SiteSelect/SiteSelect';

interface Props {
  onSiteSelected: (site: SiteData) => void;
}

export const AddHospitalStepSearch = ({
  onSiteSelected,
}: Props): ReactElement => {
  const { t } = useCommonTranslation();
  const [siteLoading, setSiteLoading] = useState(false);

  const handleSiteIdSelect = useCallback(
    async (siteId: string) => {
      try {
        setSiteLoading(true);
        onSiteSelected((await getSiteById(siteId)).data);
      } catch (err) {
        errorToast(err);
      } finally {
        setSiteLoading(false);
      }
    },
    [onSiteSelected],
  );

  const isLoading = siteLoading;

  return (
    <>
      {isLoading ? (
        <CardLoader />
      ) : (
        <>
          <FormTitle>{t('select-hospital')}</FormTitle>
          <FormLargeDesc>
            {t('sites-hospital-select-title', {
              searchMinLength: SITE_SELECT_SEARCH_MIN_LENGTH,
            })}
          </FormLargeDesc>
          <SiteSelect onSiteSelect={(site) => handleSiteIdSelect(site.id)} />
        </>
      )}
    </>
  );
};
